import React from 'react';
import { OptionsAssetIcon } from './OptionsAssetIcon';
import { getCurrencyVisual } from './optionsVisualConfig';

export const OptionsCurrencyDisplay = ({ currencyKey, iconSize = 16, compact = false }) => {
  const visual = getCurrencyVisual(currencyKey);
  const isSelectorCurrency = ['usd', 'btc'].includes(String(currencyKey || '').toLowerCase());
  return (
    <span className={`inline-flex items-center ${compact ? 'gap-2' : 'gap-2.5'}`} data-testid={`options-currency-display-${currencyKey}`}>
      {visual.assetKey ? (
        isSelectorCurrency ? (
          <OptionsAssetIcon assetKey={visual.assetKey} size={iconSize} variant="symbol" className="shrink-0" />
        ) : (
          <span className={`inline-flex items-center justify-center rounded-full border border-white/10 bg-white/[0.045] ${compact ? 'h-6 w-6' : 'h-7 w-7'}`} data-testid={`options-currency-display-${currencyKey}-icon-wrap`}>
            <OptionsAssetIcon assetKey={visual.assetKey} size={iconSize} variant="default" className="shrink-0" />
          </span>
        )
      ) : null}
      <span className={`font-semibold ${compact ? 'text-sm tracking-[0.06em]' : 'tracking-[0.08em]'}`}>{visual.label}</span>
    </span>
  );
};

export default OptionsCurrencyDisplay;